<div class="absolute bg-gradient-to-t from-[#121212] via-gray-900 via-100% to-black h-72 w-full top-0 left-0 rounded-t-lg -z-10"></div>

<article class="pt-3 grid gap-3">
    <section class="text-white">
        <h2>{{this.getGreeting()}}</h2>
        <div class="grid grid-cols-1 pt-3 sm:grid-cols-2 xl:grid-cols-3 grid-rows-3 sm:grid-rows-2 gap-2">
            @for (item of this.welcome$(); track $index) {
                <app-medium-card [value]="item"></app-medium-card>
            }
        </div>
    </section>
    @if (sections) {
        @for (item of this.sections.items; track item.id) {
            @defer (on viewport) {
                <app-section class="whitespace-nowrap overflow-hidden" [section]="item"></app-section>
            }@placeholder {
                <p></p>
            }
        }
    }
</article>